import { render, staticRenderFns } from "./action-sheet.vue?vue&type=template&id=13cede00&"
import script from "./action-sheet.vue?vue&type=script&lang=js&"
export * from "./action-sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports